{
  "messages": {
    "maximumInSizeOnlyOneImageTextZipOrSpreadsheetAllowedToUploadMultipleDocsZipFirstThenUpload": "大小上限为 {size}。仅允许{imageLimit}、{typeLimitText}、{typeLimitZip}或{typeLimitSpreadsheet}。如需上传多个文档，请先压缩为 zip 再上传。",
    "maximumInSizePerFileOnlyImageTextZipSpreadsheetAllowed": "每个文件大小上限为 {size}。最多 {count} 个文件。仅允许{image}、{text}、{zip}或{spreadsheet}。",
    "oneImage": "一张图片",
    "sizeInMegabytes": "{size} MB",
    "uploadDocument": "上传文档",
    "uploadDocuments": "上传文档"
  }
}
